import React from 'react';
import { Typography } from '@material-ui/core';
import Container from '@mui/material/Container';
import { Box } from '@mui/system';

const Blurb = () => {

  return (
      <Container align="center" maxWidth="md">
        <Box
          sx={{
            marginTop: '1em',
            display: 'flex',
            flexDirection: { xs: 'column' },
            alignItems: 'center',
            bgcolor: 'background.paper',
            overflow: 'hidden',
            borderRadius: '12px',
            boxShadow: 1,
            fontWeight: 'bold',
          }}
        >
          <Typography variant="h4" gutterBottom >Due to the postal strike, the shop is temporarily closed.</Typography>
          <Typography variant="h6" align="left" gutterBottom>

          </Typography>
        </Box>
      </Container>
  );
}

export default Blurb;